import _ from 'lodash';

export default function(requestBody) {

  if (requestBody.custom_fields) {
    for (let i = 0; i < requestBody.custom_fields.length; i++) {
      let value = _.get(requestBody.custom_fields[i], 'value');
      if (!_.isBoolean(value) && value === 'placeholder') {
        requestBody.custom_fields.splice(i, 1)
      }
    }
  }

  if (requestBody.address) {
    for (let addressField in requestBody.address) {
      const value = requestBody.address[addressField]
      if (
        !_.isNumber(value) && !_.isBoolean(value) && _.isEmpty(value)
      ) {
        delete requestBody.address[addressField];
      }
    }
  }

  for (let field in requestBody) {
    const value = requestBody[field];
    if (
      !_.isNumber(value) && !_.isBoolean(value) && _.isEmpty(value)
    ) {
      delete requestBody[field];
    }
  }

  if (requestBody.firstName) {
    requestBody.first_name = requestBody.firstName
    delete requestBody.firstName
  }

  if (requestBody.lastName) {
    requestBody.last_name = requestBody.lastName
    delete requestBody.lastName
  }

  return requestBody;
}
